// @ts-strict

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ISingleCampaign } from '@app/core/models/core-models';
import { BehaviorSubject, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { CPA_LOCKER_CAMPAIGN_DETAILS_GET } from '@app/core/helpers/api.constants';
import { DefaultApiResponse } from '@app/core/models/api-types';

export enum CAMPAIGN_PREVIEW_VIEW_TYPE {
  locker_campaigns = 'locker_campaigns',
  campaigns = 'campaigns'
}
@Injectable({
  providedIn: 'root'
})
export class CampaignPreviewService {
  constructor(private readonly http: HttpClient) {}

  private _loadingSubject = new BehaviorSubject<boolean>(false);
  private _errorSubject = new BehaviorSubject<any | boolean>(false);

  isLoading$ = this._loadingSubject.asObservable();
  error$ = this._errorSubject.asObservable();

  public getSingleCampaign(campaignId: number, viewType: CAMPAIGN_PREVIEW_VIEW_TYPE) {
    this._loadingSubject.next(true);
    this._errorSubject.next(false);

    return this.http
      .get<DefaultApiResponse<ISingleCampaign>>(environment.apiUrl + CPA_LOCKER_CAMPAIGN_DETAILS_GET(campaignId), {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        params: { view_type: viewType }
      })
      .pipe(
        map(({ data }) => data),
        catchError(err => {
          this._errorSubject.next(err);
          return of({});
        }),
        finalize(() => this._loadingSubject.next(false))
      );
  }
}
